<template src="./tempoEmailService.template.html"></template>
<script>
    export default {
        // options
        name: "tempoEmailServiceComponent",
        props: [],
        data() {
            return {
                maildev: null
            };
        },
        methods: {

            getMaildevUrl() {
                let domainName = window.location.hostname
                let domainProtocol = window.location.protocol
                if (domainName === "localhost" || domainName === "192.168.1.225") {
                    this.maildev = domainProtocol + "//" + domainName + ':' + '1080' + '/maildev'
                }
                else {
                    this.maildev = domainProtocol + "//" + domainName + '/maildev'
                }
                this.$store.commit("setMaildevUrl",   this.maildev);
            }
        },
        computed: {

        },
        watch: {


        },
        mounted() {
            this.getMaildevUrl();
        }
    }

</script>